import type {CancelablePromise} from '../types/CancelablePromise';
import type {VatCalculation} from '../types/VatCalculation';
import {request as __request} from '../utils/request';

export class DefaultService {
  /**
   * @returns VatCalculation
   * @throws ApiError
   */
  public static calculateFromWithVat({
    countryCode,
    vatRateType,
    amount,
    date,
  }: {
    countryCode: string;
    vatRateType: string;
    amount: string;
    date?: string;
  }): CancelablePromise<VatCalculation> {
    return __request({
      method: 'GET',
      url: '/common/v1/vat-calculation/from-with-vat',
      query: {
        countryCode,
        vatRateType,
        amount,
        date,
      },
    });
  }

  /**
   * @returns VatCalculation
   * @throws ApiError
   */
  public static calculateFromWithoutVat({
    countryCode,
    vatRateType,
    amount,
    date,
  }: {
    countryCode: string;
    vatRateType: string;
    amount: string;
    date?: string;
  }): CancelablePromise<VatCalculation> {
    return __request({
      method: 'GET',
      url: '/common/v1/vat-calculation/from-without-vat',
      query: {
        countryCode,
        vatRateType,
        amount,
        date,
      },
    });
  }
}
